<template>
    <div>
        <div class="card-header">
            Send invoice to client
        </div>
        <div class="card-body">
            <p class="invoice-state-description">
                Create the invoice and send it to the client, make sure this is done before marking the invoice as sent.
            </p>
            <div class="row">
                <div class="col-md-6">
                    <confirm-toggle v-model="accepted" label="I have sent invoice manually"></confirm-toggle>
                </div>
                <div class="col-md-6">
                    <button type="submit" class="btn btn-primary btn-block" @click.prevent="send"
                            :disabled="!accepted">Mark invoice as sent
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import DefaultState from './DefaultState';

  export default {
    name: 'Accepted',
    extends: DefaultState,
    data() {
      return {
        accepted: false,
      };
    },
    methods: {
      send() {
        this.action({transition: this.getTransition('Sent')});
      },
    },
  };
</script>

<style scoped>

</style>
